import TermsPage from 'info/terms';

export default TermsPage;
